import { SurveyService } from './surveys.service';

const POLL_INTERVAL_MS = 5000;
const POLL_MAX_ATTEMPTS = 120;

export class ConsensusSubsetDegrees {
  loading = false;
  private results: { [questionId: string]: any } = {};
  private filterKey: string | null = null;
  private timer: any = null;
  private attempts = 0;

  constructor(private surveyService: SurveyService, private onUpdate: () => void) {}

  get hasResults(): boolean {
    return Object.keys(this.results).length > 0;
  }

  sync(filters: any): void {
    const key = JSON.stringify(filters ?? {});
    if (key !== this.filterKey) {
      this.filterKey = key;
      this.results = {};
      this.stop();
    }
  }

  apply(question: any): void {
    const result = this.results[String(question?.id)];
    if (!result) {
      return;
    }
    question.paraconsistent = result;
    question.degreesFiltered = false;
    question.degreesScope = 'filter';
  }

  request(surveyId: number, questions: any[], filters: any): void {
    const payload = questions
      .filter(question => this.surveyService.isConsensusQuestion(question?.typology))
      .map(question => ({
        question_id: question.id,
        response_ids: (question.responses || []).map((response: any) => response.id).filter((id: any) => id !== undefined && id !== null),
      }));
    if (!surveyId || payload.length === 0) {
      return;
    }
    this.stop();
    this.attempts = 0;
    this.send(surveyId, payload, filters);
  }

  dispose(): void {
    this.stop();
  }

  private send(surveyId: number, payload: any[], filters: any): void {
    const key = this.filterKey;
    this.loading = true;
    this.surveyService.requestConsensusSubsetAnalytics(surveyId, payload, filters, (response: any) => {
      if (key !== this.filterKey) {
        return;
      }
      this.results = { ...this.results, ...(response?.questions ?? {}) };
      this.loading = !!response?.pending;
      this.onUpdate();
      if (response?.pending && this.attempts < POLL_MAX_ATTEMPTS) {
        this.attempts++;
        this.timer = setTimeout(() => this.send(surveyId, payload, filters), POLL_INTERVAL_MS);
      } else {
        this.loading = false;
      }
    }, () => {
      this.loading = false;
    });
  }

  private stop(): void {
    clearTimeout(this.timer);
    this.timer = null;
    this.loading = false;
  }
}
